export enum UploadTaskActionTypes {
    UPLOADTASK_REQUEST_SEND = 'uploadtask_request_send',
    UPLOADTASK_ERROR = 'uploadtask_error',
    UPLOADTASK_SUCCESS = 'uploadtask_success',
    
    UPLOADTASK_CREATE_REQUEST = 'uploadtask_create_request',
    UPLOADTASK_CREATE_SUCCESS = 'uploadtask_create_success',
    UPLOADTASK_CREATE_ERROR = 'uploadtask_create_error',

    UPLOADTASK_DELETE_REQUEST = 'uploadtask_delete_request',
    UPLOADTASK_DELETE_SUCCESS = 'uploadtask_delete_success',
    UPLOADTASK_DELETE_ERROR = 'uploadtask_delete_error',

    UPLOADTASK_UPDATE_REQUEST = 'uploadtask_update_request',
    UPLOADTASK_UPDATE_SUCCESS = 'uploadtask_update_success',
    UPLOADTASK_UPDATE_ERROR = 'uploadtask_update_error',
}